export default __webpack_public_path__ + "static/media/bookeAiStatusXero.50d352ef.png";